class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.updateMobileGarmentScroll = this.updateMobileGarmentScroll.bind(this);

    this.minimumObserver = new MutationObserver(() => {
      if (this.notification.classList.contains('active')) {
        this.updateMobileGarmentScroll();
      }
    });
    this.minimumObserver.observe(this.notification, { childList: true, subtree: true });

    window.addEventListener('resize', this.updateMobileGarmentScroll);
    window.addEventListener('orientationchange', this.updateMobileGarmentScroll);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  updateMobileGarmentScroll() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const hasGarmentMinimums = Boolean(
      this.notification.querySelector('.snf-minimum-panel')
    );

    if (!isMobile || !hasGarmentMinimums || !this.notification.classList.contains('active')) {
      this.notification.style.removeProperty('max-height');
      this.notification.style.removeProperty('overflow-y');
      this.notification.style.removeProperty('overscroll-behavior');
      this.notification.style.removeProperty('touch-action');
      this.notification.style.removeProperty('-webkit-overflow-scrolling');
      return;
    }

    const top = Math.max(0, this.notification.getBoundingClientRect().top);
    const availableHeight = Math.max(240, window.innerHeight - top - 8);

    this.notification.style.maxHeight = `${availableHeight}px`;
    this.notification.style.overflowY = 'auto';
    this.notification.style.overscrollBehavior = 'contain';
    this.notification.style.touchAction = 'pan-y';
    this.notification.style.webkitOverflowScrolling = 'touch';
  }

  open() {
    this.notification.classList.add('animate', 'active');

    requestAnimationFrame(this.updateMobileGarmentScroll);
    window.setTimeout(this.updateMobileGarmentScroll, 150);
    window.setTimeout(this.updateMobileGarmentScroll, 600);

    this.notification.addEventListener('transitionend', () => {
      this.updateMobileGarmentScroll();
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.scrollTop = 0;
    this.updateMobileGarmentScroll();
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
